import { Colors } from "@zapier/design-system";

export function getNodeResizerHandleStyle(isEditable: boolean = false) {
  return {
    width: "12px",
    height: "12px",
    border: `2px solid ${isEditable ? "#4a90e2" : Colors.UiPrimaryStronger}`,
    background: Colors.GrayWarm2,
  };
}

export function getNodeResizerLineStyle(isEditable: boolean = false) {
  return {
    color: Colors.UiPrimaryStronger,
    border: `1px solid ${isEditable ? "#4a90e2" : Colors.UiPrimaryStronger}`,
  };
}
